import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

import { EventoFornecedor, Fornecedor } from './models/fornecedor';
import { UsuarioFornecedor } from '../usuario/models/usuario';
import { filtroDashboard } from '../dashboard/models/dashboard';


@Injectable({
    providedIn: 'root'
})

export class FornecedorService {

    private environmentUrl: string = '';

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

    getFornecedores(): Observable<Fornecedor[]> {
        let url = this.environmentUrl + "/fornecedor/";
        return this.httpClient.get<Fornecedor[]>(url);
    }

    getFornecedor(idFornecedor: number): Observable<Fornecedor> {
        let url = this.environmentUrl + "/fornecedor/" + idFornecedor;
        return this.httpClient.get<Fornecedor>(url);
    }

    addFornecedor(fornecedor: Fornecedor) {
        return this.httpClient.post(this.environmentUrl + "/fornecedor", fornecedor);
    }

    updFornecedor(fornecedor: Fornecedor) {
        return this.httpClient.put(this.environmentUrl + "/fornecedor", fornecedor);
    }

    delFornecedor(idfornecedor: number) {
        return this.httpClient.delete(this.environmentUrl + "/fornecedor/" + idfornecedor);
    }

    getUsuarioFornecedores(): Observable<UsuarioFornecedor[]> {
        let url = this.environmentUrl + "/fornecedor/";
        return this.httpClient.get<UsuarioFornecedor[]>(url);
    }


    //EventoFornecedor

    getFornecedoresSemEvento(idEvento: number): Observable<Fornecedor[]> {
        let url = this.environmentUrl + "/fornecedor/SemEvento/" + idEvento;
        return this.httpClient.get<Fornecedor[]>(url);
    }


    getEventoFornecedores(idEvento: number): Observable<Fornecedor[]> {
        let url = this.environmentUrl + "/eventofornecedor/evento/" + idEvento;
        return this.httpClient.get<Fornecedor[]>(url);
    }

    getEventoFornecedor(idEventoFornecedor: number): Observable<EventoFornecedor> {
        let url = this.environmentUrl + "/eventofornecedor/" + idEventoFornecedor;
        return this.httpClient.get<EventoFornecedor>(url);
    }

    addEventoFornecedor(eventoFornecedor: EventoFornecedor) {
        console.log(eventoFornecedor);
        
        return this.httpClient.post(this.environmentUrl + "/eventofornecedor", eventoFornecedor);
    }

    updEventoFornecedor(eventoFornecedor: EventoFornecedor) {
        return this.httpClient.put(this.environmentUrl + "/eventofornecedor", eventoFornecedor);
    }

    delEventoFornecedor(idEventoFornecedor: number) {
        return this.httpClient.delete(this.environmentUrl + "/eventofornecedor/" + idEventoFornecedor);
    }

    getFornecedoresDashboard(idEvento: string){
        return this.httpClient.get<filtroDashboard[]>(this.environmentUrl + "/eventofornecedor/FiltroDashboard/"+ idEvento);
    }

    existeFornecedor(fornecedor: string){
        return this.httpClient.get(this.environmentUrl + "/fornecedor/existeFornecedor/" + fornecedor);
    }
}


